import React, { Component } from 'react';

import { connect } from 'react-redux';

import XLSX from 'xlsx';

import { PRIMARY_KEY, ID_TEMPLATE } from '../backend/model.js';
import { DBImpMain, DBImpSide, SelectSideItem } from '../dumb_component';
import { DATABASE } from '../backend/model';

class DatabaseImporter extends Component {
  constructor(props) {
    super(props);
    this.state = {
      DBBlueprint: {},
      DBFields: {},
      newFileTemplate: {},
      newFilesFields: {},
      usedFields: [],
      sheetsWithDoubledFields: [],
      sheetsWithUnsetFields: [],
      selectSide: [],
      table: 'choose',
      activeSheet: this.props.workbook.SheetNames[0],
      sheetFormattedFields: {},
      sheetWithMissingPrimaryKey: []
    };
  };

  componentDidMount() {
    let DBFields = this.getDBFields({});
    let [newFileTemplate, newFilesFields] = this.stripeNewFile({}, {});
    let optionsSide = this.setOptionsSide();
    let selectSide = this.setSelectSide(optionsSide);
    let optionsMain = this.setOptionsMain(DBFields);
    let optionsMainID = this.setOptionsMainID();
    let selectMain = this.setSelectMain(newFileTemplate, optionsMain, optionsMainID, DBFields);
    let sheetsWithUnsetFields = [];
    let sheetFormattedFields = this.formatSheetFields(this.props.workbook.SheetNames[0], newFileTemplate);

    this.props.workbook.SheetNames.forEach(sheet => {
      if(Object.keys(this.props.workbook.Sheets[sheet]).length > 1)
        sheetsWithUnsetFields.push(sheet);
    });

    this.setState({
      DBFields,
      newFileTemplate,
      newFilesFields,
      usedFields: [],
      selectSide,
      selectMain,
      sheetsWithUnsetFields,
      sheetFormattedFields
    });
  };

  componentDidUpdate() {
    const { selectMain, DBBlueprint, table, activeSheet } = this.state;

    for(let i = 0; i < selectMain.flat().length; i++) {
      let el = document.getElementsByClassName('result-item')[i];
      if(!!el) {
        let selectValue = el.children[2].firstChild.value;
        let [table, value] = selectValue.split(':::');
        let testArray = {};
  
        if(value === PRIMARY_KEY && table != 'ignore') {
          if(DBBlueprint[table][PRIMARY_KEY] != undefined) {
            DBBlueprint[table][PRIMARY_KEY].table.forEach(v => {
              if(testArray[v] == undefined)
               testArray[v] = 0;
              testArray[v]++;
            });
          };
        };
  
        let bool = false;
        if(el.className.includes(activeSheet)) {
          let elClass = el.className.slice(el.className.indexOf(' ') + 1);
          bool = elClass == activeSheet;
        }
  
        el.style.display = bool ? 'flex' : 'none';
        if(bool)
          el.style.background = table == 'ignore' ? '#ddd' : DBBlueprint[table] ? DBBlueprint[table][value] ? value !== PRIMARY_KEY ? DBBlueprint[table][value].table.length > 1 ? '#f11' : '#fff' : testArray[activeSheet] ? testArray[activeSheet] > 1 ? '#f11' : '#fff' : '#fff' : '#fff' : '#fff';
      }

    };

    let options = document.getElementsByClassName('options-main');

    for(let i = 0; i < options.length; i++) {
      let el = options[i];
      let bool = false;
      if(el.className.includes(table)) {
        let elClass = el.className.slice(el.className.indexOf(' ') + 1);
        bool = elClass == table;
      }
      el.style.display = bool ? 'flex' : 'none';
    };
  };

  // switch every letter to get any letter combination possible
  perm = (xs) => {
    let ret = [];
  
    for (let i = 0; i < xs.length; i = i + 1) {
      let rest = this.perm(xs.slice(0, i).concat(xs.slice(i + 1)));
  
      if(!rest.length) {
        ret.push([xs[i]])
      } else {
        for(let j = 0; j < rest.length; j = j + 1) {
          ret.push([xs[i]].concat(rest[j]))
        }
      }
    }
    return ret;
  }

  getDBFields = (initObj) => {
    Object.keys(DATABASE).forEach(val => {
      Object.keys(DATABASE[val]).forEach(innerVal => {
        if(initObj[innerVal] == undefined)
          initObj[innerVal] = [];
        initObj[innerVal].push(val);
      });
    });
    return initObj;
  };

  stripeNewFile = (initNewFileTemplate, initNewFilesFields) => {
    const { workbook } = this.props;
    let fieldsIndexes = 0;
    workbook.SheetNames.forEach(n => {
      let aoa = XLSX.utils.sheet_to_json(workbook.Sheets[n], { header: 1 });
      let hasMerges = !!workbook.Sheets[n]['!merges'];
      let fields = aoa[hasMerges ? 1 : 0].flat();

      fields = fields ? fields : [];
      //let uppedFields = fields.map(field => field.replace(/\s/gi, '_').toUpperCase());
      if(hasMerges) {
        hasMerges = {};
        workbook.Sheets[n]['!merges'].forEach(merges => {
          hasMerges[aoa[0][merges.s.c]] = [merges.s.c, merges.e.c];
        });
      }
      let arr = {};
      arr.hasMerges = hasMerges;
      arr.fields = fields;
      arr.indexes = [fieldsIndexes, fieldsIndexes + fields.length];
      fieldsIndexes += fields.length;
      arr.usedTables = [];
      initNewFileTemplate[n] = arr
    });
    Object.keys(initNewFileTemplate).forEach(val => {
      initNewFileTemplate[val].fields.forEach(innerVal => {
        if(initNewFilesFields[innerVal] == undefined)
          initNewFilesFields[innerVal] = [];
        initNewFilesFields[innerVal].push(val);
      });
    });
    return [initNewFileTemplate, initNewFilesFields];
  };

  setDBBlueprint = (DBFields, newFilesFields) => {
    let obj = { ...this.state.DBBlueprint };
    Object.keys(DBFields).forEach(dbField => {
      if(Object.keys(newFilesFields).includes(dbField)) {
        if(obj[DBFields[dbField][0]] == undefined)
          obj[DBFields[dbField][0]] = {};
        obj[DBFields[dbField][0]][dbField] = {
          table: newFilesFields[dbField],
          field: dbField
        };
      };
    });
    return obj;
  };

  setOptionsSide = () => {
    return Object.keys(DATABASE).map((field, index) => <option value={field} key={index}>{field}</option>);
  };

  setSelectSide = optionsSide => {
    //return <SelectItem onSelectSideChange={this.onSelectSideChange} optionsSide={optionsSide} />
    
    return(
      <div
        style={{ flex: 0, padding: '1vw'}}
        onChange={(e) => this.onSelectSideChange(e.target.value) }>
        <select id='select-side' defaultValue={'choose'}>
          <option value={'choose'} key={'096/875652'}>Choisir une table</option>
          {optionsSide}
        </select>
      </div>
    );
  };

  onSelectSideChange = table => {
    const { newFileTemplate, activeSheet, DBBlueprint, usedFields, sheetFormattedFields} = this.state;

    if(table !== 'choose'){
      let tmp = [ ...Object.keys(DATABASE[table]), ...Object.keys(DATABASE['ID']) ];

      tmp.forEach(field => {
        let autocompletFormattedField = field.split('_');

        autocompletFormattedField = this.perm(autocompletFormattedField);

        autocompletFormattedField = autocompletFormattedField.map(f=> {
          let lowered = f.map(l => l.toLowerCase())
          let concatted = lowered.toString().replace(/,/g, '');
          return concatted;
        });

        if(autocompletFormattedField.some(e => Object.keys(sheetFormattedFields).includes(e)) || usedFields[field] !== undefined){
          let extractedFormattedField = '';
          autocompletFormattedField.forEach(s => {
            if(!!sheetFormattedFields[s]) {
              extractedFormattedField = sheetFormattedFields[s];
            }
          });
          for(let i = newFileTemplate[activeSheet].indexes[0]; i < newFileTemplate[activeSheet].indexes[1]; i++) {
            let el = document.getElementsByClassName('result-item')[i];
            if(!!el) {
              let select = el.children[2].firstChild;
              let [newFileTable, newFileValue] = select.nextSibling.innerHTML.split(':::');
              let fieldNotSetYet = DBBlueprint[table] ? DBBlueprint[table][field] ? false : true : true;
              let alreadyUsedField = usedFields[field] ? usedFields[field].includes(newFileValue) ? true : false : false;
              if(select.value === 'ignore:::ignore' && fieldNotSetYet && (newFileValue === extractedFormattedField || alreadyUsedField)) {
                select.value = `${table}:::${field}`;
              };
            }
          };
        };
      })};
    this.saveChanges(table);
  };

  setOptionsMain = DBFields => {
    let optionsMain = Object.keys(DBFields).map((field, index) => {
      return DBFields[field].map((table, index) => {
        let className = `options-main ${table}`;
        return <option value={`${table}:::${field}`} key={index} className={className}>{`[${table}]: ${field}`}</option>
      });
    });
    return optionsMain;
  };

  setOptionsMainID = () => {
    let optionsMainID = Object.keys(DATABASE).map((tableName, index) => {
      let className = `options-main ${tableName}`;
      if(tableName !== 'ID')
      return Object.keys(DATABASE.ID).map((key, index) => {
        return( <option value={`${tableName}:::${key}`} key={index} className={className}>{`${key}`}</option> );
      });
    });
    return optionsMainID;
  };

  setSelectMain = (newFilesFields, optionsMain, optionsMainID, DBFields = this.state.DBFields) => {
    let activeSheet = this.state.activeSheet == undefined ? this.props.workbook.SheetNames[0] : this.state.activeSheet;
    let selectMain = Object.keys(newFilesFields).map((table, index) => {
      let className = `result-item ${table}`;
      let fields = newFilesFields[table].fields.map((field, innerIndex) => {
        return(
          <div
            key={table + field + index + innerIndex}
            className={className}
            style={{ display: table == activeSheet ? 'flex' : 'none'}}
            onChange={(e) => {
              e.stopPropagation();
              e.target.value === 'dash:::dash' ? e.target.value = 'ignore:::ignore' : this.saveChanges()
              } }>
            <div className='select-name'>
              {field}
            </div>
            <div id='separator'>{'=>'}</div>
            <div style={{ alignItems: 'center', justifyContent: 'center' }}>
              <select
                defaultValue={'ignore:::ignore'}>
                  <option value={'ignore:::ignore'} key={'096/87575652'}>Ignorer</option>
                  <option value={'dash:::dash'} key={'09/6854223'}></option>
                  {this.existingField(DBFields, field)}
                  {optionsMain}
                  <option value={'dash:::dash'} key={'09/685422D3'}></option>
                  {optionsMainID}
              </select>
              <div style={{ display: 'none'}}>{table}:::{field}</div>
            </div>
          </div>
        );
      })
      return fields
    });
    return selectMain;
  }

  /**
   * Change sheet and set the table on the side to the default value unless the sheet has already been using a table, then the latest table used will be set
   */
  setSheet = sheetName => {
    const { newFileTemplate } = this.state;
    let relatedTable = newFileTemplate[sheetName].relatedTable ? newFileTemplate[sheetName].relatedTable : 'choose';
    document.getElementById('select-side').value = relatedTable;

    let sheetFormattedFields = this.formatSheetFields(sheetName);

    this.setState({
      activeSheet: sheetName,
      table: relatedTable,
      sheetFormattedFields
    });
  };

  formatSheetFields = (sheetName, newFileTemplate = this.state.newFileTemplate) => {
    let sheetFormattedFields = {};
    
    Object.values(newFileTemplate[sheetName].fields).forEach(field => {
      let loweredField = field.toLowerCase();

      let aRegex = /[àâä]/g;
      let eRegex = /[éèêë]/g;
      let iRegex = /[îï]/g;
      let oRegex = /[ôö]/g;
      let uRegex = /[ûüù]/g;

      let formattedField = loweredField.replace(aRegex, 'a');
      formattedField = formattedField.replace(eRegex, 'e');
      formattedField = formattedField.replace(iRegex, 'i');
      formattedField = formattedField.replace(oRegex, 'o');
      formattedField = formattedField.replace(uRegex, 'u');
      formattedField = formattedField.replace(/ /g, '');
      formattedField = formattedField.replace(/_/g, '');
      formattedField = formattedField.replace(/-/g, '');
      formattedField = formattedField.replace(/'/g, '');
      //formattedField = formattedField.replace(/1/g, 'i');
      //formattedField = formattedField.replace(/2/g, 'ii');
      
      sheetFormattedFields[formattedField] = field;
    });

    return sheetFormattedFields
  }

  saveChanges = (table = this.state.table) => {
    let obj = {};
    let usedFields = {};
    let sheetsWithDoubledFields = [];
    let sheetsWithUnsetFields = [];
    let selects = document.getElementsByClassName('result-item');
    let tablesRelation = {}

    for(let i = 0; i < selects.length; i++) {
      let select = selects[i].children[2].firstChild;
      let [table, value] = select.value.split(':::');
      let [newFileTable, newFileValue] = select.nextSibling.innerHTML.split(':::');
      if(table !== 'ignore') {

        // Establishing table's relation 
        if(tablesRelation[newFileTable] == undefined)
          tablesRelation[newFileTable] = [];
        tablesRelation[newFileTable].push(table);
        // end
        /*if(value != 'choose'){
          console.log(value)
        }*/
        let existingArrayOfTable = obj[table] ? obj[table][value] ? obj[table][value].table ? obj[table][value].table : [] : [] : [];
        existingArrayOfTable.push(newFileTable)
        obj[table] = {...obj[table], [value]: { field: newFileValue, table: existingArrayOfTable }};
        
        if(usedFields[value] == undefined)
          usedFields[value] = [];
        usedFields[value].push(newFileValue);
        usedFields[value] = usedFields[value].filter((value, index, self) => self.indexOf(value) === index );
        if(value !== PRIMARY_KEY) {
          let bool = obj[table] ? obj[table][value] ? obj[table][value].table.length > 1 ? true : false : false: false;
          if(bool)
            sheetsWithDoubledFields.push(obj[table][value].table);
        } else {
          if(obj[table][PRIMARY_KEY] != undefined) {
            let testArray = {};
            obj[table][PRIMARY_KEY].table.forEach(v => {
              if(testArray[table] == undefined)
                testArray[table] = [];
              testArray[table].includes(v) ? sheetsWithDoubledFields.push(v) : testArray[table].push(v)
            });
          };
        }
        if(Object.keys(ID_TEMPLATE).some(e => e == value)) {
          obj['ID'] = {...obj['ID'], [value]: { field: newFileValue, table: existingArrayOfTable }};
        }
      }
      else {
        if(!sheetsWithUnsetFields.includes(newFileTable))
          sheetsWithUnsetFields.push(newFileTable);
      };
    };

    let tmp = { ...this.state.newFileTemplate };
    tmp[this.state.activeSheet].relatedTable = table;

    // Makes any contained value unique
    sheetsWithDoubledFields = sheetsWithDoubledFields.flat().filter((value, index, self) => self.indexOf(value) === index);
    Object.keys(tablesRelation).forEach(table => {
      tablesRelation[table] = tablesRelation[table].filter((value, index, self) => self.indexOf(value) === index );
    });
    // end

    let sheetWithMissingPrimaryKey = [];

    // Checking at least one Primary Key in each sheet  // ERROR => undefined if user don't set anything
    Object.keys(tablesRelation).forEach(sheet => {
      let sheetHasPrimaryKey = false;
      tablesRelation[sheet].forEach(table => {
        if(Object.keys(obj[table]).includes(PRIMARY_KEY))
          sheetHasPrimaryKey = true;
      });
      if(!sheetHasPrimaryKey)
        sheetWithMissingPrimaryKey.push(sheet);
    });

    this.setState({
      usedFields,
      DBBlueprint: obj,
      newFileTemplate: tmp,
      table,
      sheetsWithDoubledFields,
      sheetsWithUnsetFields,
      tablesRelation,
      sheetWithMissingPrimaryKey
    });
  };

  existingField = (DBFields, field) => {
    if(DBFields[field] != undefined) {
      let obj = DBFields[field].map((table, index) => {
        return <option value={`${table}:::${field}`} key={table + field + index}>{`[${table}]: ${field}`}</option>
      });
      return obj;
    }
  }

  cleanString = (tx) => {
    tx = tx.replace('&amp;', '&');
    return tx
  }

  readyDBBlueprint = () => {
    const { workbook, validate } = this.props;
    const { DBBlueprint, newFileTemplate, tablesRelation } = this.state;

    //console.log('DATABASE BLUEPRINT', DBBlueprint);
    //console.log('NEW FILE TEMPLATE', newFileTemplate);

    let primaryKeyVerification = false;
    let miss = ''
    let tableWithMissingPrimaryKey = [];
    let sheetWithMissingPrimaryKey = [];

    // Checking at least one Primary Key in each sheet  // ERROR => undefined if user don't set anything
    Object.keys(tablesRelation).forEach(sheet => {
      let sheetHasPrimaryKey = false;
      tablesRelation[sheet].forEach(table => {
        if(Object.keys(DBBlueprint[table]).includes(PRIMARY_KEY)){
          sheetHasPrimaryKey = true;
        }
      });
      if(!sheetHasPrimaryKey)
        sheetWithMissingPrimaryKey.push(sheet);
    });
    // end

    if(!sheetWithMissingPrimaryKey.length) {
      
      let primaryKey = {};
      let tableWithMissingPrimaryKey = [];

      // In sheets spreaded accross multiple tables, making such each table receive the Primary key
      Object.keys(tablesRelation).forEach(sheet => {
        tablesRelation[sheet].forEach(table => {
          if(!Object.keys(DBBlueprint[table]).includes(PRIMARY_KEY))
            tableWithMissingPrimaryKey.push(table);
          else {
            primaryKey = DBBlueprint[table][PRIMARY_KEY];
          }
        });
        tableWithMissingPrimaryKey.forEach(table => {
          DBBlueprint[table][PRIMARY_KEY] = primaryKey;
        });
      });
      // end

      let database = {};

      // Readying the excel ready object
      Object.keys(DBBlueprint).forEach(table => {
        database[table] = {
          columnNames: Object.keys(DBBlueprint[table]),
          hasMerges: false
        };
        let indexOfPrimaryKey = database[table].columnNames.indexOf(PRIMARY_KEY);

        let tableContent = [];
        let mergedField = {};
        Object.keys(DBBlueprint[table]).forEach(column => {
          let newFileTable = DBBlueprint[table][column].table[0];
          newFileTable = this.cleanString(newFileTable);
          let newFileTableContent = XLSX.utils.sheet_to_json(workbook.Sheets[newFileTable], { header: 1, raw: false }).filter(a => a.length > 0);
          let hasMerges = database[table].hasMerges = newFileTemplate[newFileTable].hasMerges;
          let fieldIndex = newFileTableContent[database[table].hasMerges ? 1 : 0].indexOf(DBBlueprint[table][column].field);
          if(hasMerges) {
            Object.keys(hasMerges).forEach(field => {
              if(fieldIndex >= hasMerges[field][0] && fieldIndex <= hasMerges[field][1] && !hasMerges[field].includes(newFileTableContent[database[table].hasMerges ? 1 : 0][fieldIndex]))
                mergedField[field] == undefined ? mergedField[field] = [column] : mergedField[field].push(column);
            });
          };
          for(let i = database[table].hasMerges ? 2 : 1; i < newFileTableContent.length; i++) {
            if(tableContent[i] == undefined)
              tableContent[i] = [];
            tableContent[i].push(newFileTableContent[i][fieldIndex]);
          }
        });

        // Iterate through array to makes sure PrimaryKey is well formatted
        //tableContent = tableContent.filter((v, i, s) => v != undefined );

        // Iterate through array to makes sure PrimaryKey is well formatted
        tableContent = tableContent.filter((v, i, s) => {

          // To take action on bad Primarykey, work here
          /*if( !Number.isInteger(v[indexOfPrimaryKey]) ) {
            console.log("dropped", v)
          }*/

          v[indexOfPrimaryKey] = parseInt(v[indexOfPrimaryKey]);
          return v != undefined && Number.isInteger(v[indexOfPrimaryKey])
        });

        //console.log('TABLE CONTENT FILTERED', tableContent)
        if(!!Object.keys(mergedField).length){
          let a = tableContent.shift();
          //console.log('shift', a);
        }
      database[table].hasMerges = mergedField;
      //console.log('TABLE CONTENT HAS SHIFT IF MERGES', tableContent)
      database[table].content = tableContent;
    });
    console.log('to backend :', database);
    validate(database);
    } else {
      // Create alert pinpointing tables with missing unique ID
      console.log('Sheets have misssing primary keys :', sheetWithMissingPrimaryKey);
    }
};

  render() {
    const { workbook } = this.props;
    const {
      table,
      aoa,
      selectMain,
      selectSide,
      DBBlueprint,
      sheetWithMissingPrimaryKey,
      sheetsWithDoubledFields, 
      sheetsWithUnsetFields,
      activeSheet,
      sheetFormattedFields
    } = this.state;

    console.log('Database Importer opened');

    //console.log('STATE :', this.state, 'DBBlueprint :', this.state.DBBlueprint, 'workbook', workbook, 'formatted', sheetFormattedFields);
    //console.log('Missing histo', this.state.sheetWithMissingPrimaryKey)
    
    return(
      <div>
        <DBImpMain 
          sheetNames={workbook.SheetNames}
          sheetsWithDoubledFields={sheetsWithDoubledFields}
          sheetsWithUnsetFields={sheetsWithUnsetFields}
          activeSheet={activeSheet}
          aoa={aoa} 
          content={selectMain}
          setSheet={(sheetName) => this.setSheet(sheetName)}/>
        <DBImpSide
          DBBlueprintTable={!!DBBlueprint[table] ? DBBlueprint[table] : {}}
          table={!!DATABASE[table] ? DATABASE[table] : {}}
          selectSide={selectSide}
          missingPrimaryKey={sheetWithMissingPrimaryKey}
          add={() => this.readyDBBlueprint()} />
      </div>
    );
  }
}

const mapStateToProps = state => {
  /*const { model, PRIMARY_KEY } = state.databaseReducer;
  return { model, PRIMARY_KEY };*/
}

export default connect(mapStateToProps, {})(DatabaseImporter);